__turbopack_context__.v({
  "card": "_8kf1Yq_card",
  "cardContainer": "_8kf1Yq_cardContainer",
  "cards": "_8kf1Yq_cards",
  "content": "_8kf1Yq_content",
  "custom-dot-list-style": "_8kf1Yq_custom-dot-list-style",
  "gridContainer": "_8kf1Yq_gridContainer",
  "gridItem": "_8kf1Yq_gridItem",
  "headContact": "_8kf1Yq_headContact",
  "headkutip": "_8kf1Yq_headkutip",
  "p": "_8kf1Yq_p",
  "page-body-wrap": "_8kf1Yq_page-body-wrap",
  "pagehero": "_8kf1Yq_pagehero",
  "paragraph": "_8kf1Yq_paragraph",
  "paragraph-content": "_8kf1Yq_paragraph-content",
  "phonecontent": "_8kf1Yq_phonecontent",
  "react-multi-carousel-dot": "_8kf1Yq_react-multi-carousel-dot",
  "react-multi-carousel-dot--active": "_8kf1Yq_react-multi-carousel-dot--active",
  "react-multi-carousel-list": "_8kf1Yq_react-multi-carousel-list",
  "slider": "_8kf1Yq_slider",
  "store": "_8kf1Yq_store",
  "t": "_8kf1Yq_t",
  "testimony": "_8kf1Yq_testimony",
  "title": "_8kf1Yq_title",
  "wrap-container": "_8kf1Yq_wrap-container",
  "wrap-content": "_8kf1Yq_wrap-content",
});
